import CheckInView from './components/Management/CheckInView.vue';
import { createRouter, createWebHistory } from 'vue-router';
import CeremonyOverview from './components/Management/CeremonyOverview.vue';
import ManagementView from './components/Management/ManagementView.vue';
import ConnectedDevicesView from './components/Management/ConnectedDevicesView.vue';
import EventSetupView from './components/Management/EventSetupView.vue';
import ParticipantsView from './components/Management/ParticipantsView.vue';
import OratorPrepView from './components/Management/OratorPrepView.vue';
import StudentReviewView from './components/Management/StudentReviewView.vue';
import EventExportsView from './components/Management/EventExportsView.vue';
import EventViewsView from './components/Management/EventViewsView.vue';
import PresenterView from './components/Management/PresenterView.vue';
import LowerThirdsOutput from './components/Management/LowerThirdsOutput.vue';
import MessagesView from './components/Management/MessagesView.vue';
import MainParent from './components/MainParent.vue';
import EventHome from './components/EventHome.vue';
import LoginView from './components/Login.vue';
import PublicReviewRequest from './components/PublicReviewRequest.vue';
import PublicStudentReview from './components/PublicStudentReview.vue';
import { fetchEvent } from '@/lib/api';
import { canManageMessages, hasAnyRole, hasScopedRole, isAuthenticated } from '@/lib/auth';


const routes = [
  { path: '/login', component: LoginView, meta: { public: true } },
  { path: '/review/:eventId', component: PublicReviewRequest, meta: { public: true } },
  { path: '/review/:eventId/:studentId/:token', component: PublicStudentReview, meta: { public: true } },
  { path: '/', component: MainParent, props: { childComponent: EventHome } },
  { path: '/manage/messages', component: MainParent, props: { childComponent: MessagesView }, meta: { messages: true, roles: ['internal_admin', 'uni_admin'] } },
  { path: '/events/:eventId/overview', component: MainParent, props: { childComponent: CeremonyOverview }, meta: { roles: ['internal_admin', 'uni_admin', 'operator', 'orator', 'av'] } },
  { path: '/events/:eventId/ready', component: MainParent, props: { childComponent: CeremonyOverview }, meta: { roles: ['internal_admin', 'uni_admin'] } },
  { path: '/events/:eventId/setup', component: MainParent, props: { childComponent: EventSetupView }, meta: { roles: ['internal_admin', 'uni_admin'] } },
  { path: '/events/:eventId/check-in', component: MainParent, props: { childComponent: CheckInView }, meta: { roles: ['internal_admin', 'uni_admin', 'operator'] } },
  { path: '/events/:eventId/participants', component: MainParent, props: { childComponent: ParticipantsView }, meta: { roles: ['internal_admin', 'uni_admin', 'operator'] } },
  { path: '/events/:eventId/orator-prep', component: MainParent, props: { childComponent: OratorPrepView }, meta: { roles: ['internal_admin', 'uni_admin', 'orator'] } },
  { path: '/events/:eventId/review', component: MainParent, props: { childComponent: StudentReviewView }, meta: { roles: ['internal_admin', 'uni_admin'] } },
  { path: '/events/:eventId/exports', component: MainParent, props: { childComponent: EventExportsView }, meta: { roles: ['internal_admin', 'uni_admin'] } },
  { path: '/events/:eventId/views', component: MainParent, props: { childComponent: EventViewsView }, meta: { roles: ['internal_admin', 'uni_admin', 'av'] } },
  { path: '/events/:eventId/queue', component: MainParent, props: { childComponent: ManagementView }, meta: { roles: ['internal_admin', 'uni_admin', 'operator'] } },
  { path: '/events/:eventId/devices', component: MainParent, props: { childComponent: ConnectedDevicesView }, meta: { roles: ['internal_admin', 'uni_admin', 'operator'] } },
  { path: '/events/:eventId/manage', component: MainParent, props: { childComponent: ManagementView }, meta: { roles: ['internal_admin', 'uni_admin', 'operator'] } },
  { path: '/events/:eventId/presenter', component: MainParent, props: { childComponent: PresenterView }, meta: { roles: ['internal_admin', 'uni_admin', 'operator', 'orator'] } },
  { path: '/events/:eventId/lower-thirds', component: LowerThirdsOutput, meta: { roles: ['internal_admin', 'uni_admin', 'operator', 'av'] } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  if (to.meta.public) {
    return true;
  }
  if (!isAuthenticated()) {
    return { path: '/login', query: { redirect: to.fullPath } };
  }
  const allowedRoles = to.meta.roles || [];
  if (to.meta.messages && !canManageMessages()) {
    return { path: '/' };
  }
  if (!hasAnyRole(allowedRoles)) {
    return { path: '/' };
  }
  if (!(await canAccessEventRoute(to, allowedRoles))) {
    return { path: '/' };
  }
  return true;
});

async function canAccessEventRoute(to, allowedRoles) {
  const eventId = to.params.eventId;
  if (!eventId) {
    return true;
  }

  try {
    const snapshot = await fetchEvent(eventId);
    return hasScopedRole(allowedRoles, {
      eventId: snapshot.event?.eventId || eventId,
      universitySlug: snapshot.event?.universitySlug || '',
    });
  } catch (error) {
    if (error?.response?.status === 404 && to.path.endsWith('/setup')) {
      return hasScopedRole(allowedRoles, {});
    }
    return false;
  }
}

export default router;
